import { TBAFunctionalAnalysis as Component } from './component';
import Connector from './connector';

export const TBAFunctionalAnalysis = () => <Connector component={Component} />;
